module.exports = __webpack_public_path__ + "img/00972696000703.1aeec3f1.png";